import React from "react";

const Title = ({ children }) => (
  <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100 tracking-tight">
    {children}
  </h1>
);

export default Title;
